import api from './api';

// Talks to /api/inter-depot/* — the RATING half of inter-depot transport.
// Version and site come from the x-budget-version-id / x-site-code headers
// (set by the api interceptor), so nothing here passes them explicitly.
//
// Site scoping differs from planning: rating is owned by the lane's ORIGIN, so
// acting as a site shows and edits the lanes leaving it. Blank = All Sites.
export const interDepotService = {
  // { lanes, rates, manualVolumes, planningVolumes, contractors, vehicleTypes,
  //   accounts, costCenters, sites, capacityUom, config }
  getLanes: async () => {
    const res = await api.get('/inter-depot/lanes');
    return res.data;
  },

  // payload: { dest_site_code, origin_site_code?, lane_name?, distance_km?,
  //            return_factor?, volume_source? }
  // origin defaults to the acting site; All Sites must name it.
  addLane: async (payload) => {
    const res = await api.post('/inter-depot/lanes', payload);
    return res.data;
  },

  // payload: { lane_id, distance_km?, return_factor?, volume_source?, lane_name? }
  saveLane: async (payload) => {
    const res = await api.put('/inter-depot/lanes', payload);
    return res.data;
  },

  // The page toggle. Writes the default AND stamps every lane in scope.
  setVolumeSource: async (value) => {
    const res = await api.put('/inter-depot/volume-source', { value });
    return res.data;
  },

  // quantities: [12], in the network capacity unit (pallets) — the same unit
  // planning delivers, so the toggle never changes what the number means.
  saveManualVolumes: async (laneId, quantities) => {
    const res = await api.put(`/inter-depot/lanes/${laneId}/volumes`, { quantities });
    return res.data;
  },

  // payload: { lane_id, carrier_type?, contractor_code?, vehicle_type_code? }
  // Share defaults to whatever is left of 100% on the lane.
  addRateLine: async (payload) => {
    const res = await api.post('/inter-depot/rates', payload);
    return res.data;
  },

  // payload: { lines: [{ rate_line_id, ...attrs, rates: [12] }] }
  saveRateLines: async (lines) => {
    const res = await api.put('/inter-depot/rates', { lines });
    return res.data;
  },

  deleteRateLine: async (rateLineId) => {
    const res = await api.delete('/inter-depot/rates', { data: { rate_line_id: rateLineId } });
    return res.data;
  },

  // ---- Posting catalogue (Budget Setup, admin to write) --------------------
  // Where inter-depot transport lands in the ledger, scoped site → lane →
  // carrier type. Each level optional; the most specific rule wins.
  // { rules, lanes, sites, accounts, costCenters }
  getPosting: async () => {
    const res = await api.get('/inter-depot/posting');
    return res.data;
  },

  // rules: [{ posting_id?, site_code, lane_id?, carrier_type?, account_code?,
  //           cost_center_code?, notes? }] — the scope is the identity, so
  // saving the same scope twice edits the rule rather than duplicating it.
  savePosting: async (rules) => {
    const res = await api.put('/inter-depot/posting', { rules });
    return res.data;
  },

  deletePosting: async (postingId) => {
    const res = await api.delete('/inter-depot/posting', { data: { posting_id: postingId } });
    return res.data;
  },

  // ---- Contractors (Budget Setup, cross-site, admin to write) --------------
  getContractors: async () => {
    const res = await api.get('/inter-depot/contractors');
    return res.data;
  },

  saveContractors: async (contractors) => {
    const res = await api.put('/inter-depot/contractors', { contractors });
    return res.data;
  },

  deleteContractor: async (contractorCode) => {
    const res = await api.delete('/inter-depot/contractors', { data: { contractor_code: contractorCode } });
    return res.data;
  },
};

export default interDepotService;
